import React from 'react';

import { TileInfo } from 'app/home/index.functions';
import { ReportingToolIcon } from './ReportingToolIcon';
import { Box, Stack } from '@mui/material';
import { wallFormatDateShort } from 'components/wall';
import useBundleTranslation from 'i18n';
import { ElementTypeNS } from 'tools/elementType';
import { DashboardElementType } from 'tools/types';
import { useSelector } from 'react-redux';

export const ReportToolSectionLine = function ({
    style,
    tile,
    tileicons,
}: {
    style?: any;
    tile: TileInfo;
    tileicons?: { [key: string]: string };
}) {
    const defaultStyle = {};
    const { t } = useBundleTranslation('app/home');

    const isShowExpiredNote = useSelector(
        (state: any) => state.auth?.userInfo?.brandThemeProperties?.brand_theme_catalog_list_expired_elements_show,
    );
    const expiredNoteColor = useSelector(
        (state: any) => state.auth?.userInfo?.brandThemeProperties?.brand_theme_catalog_list_expired_elements_color,
    );

    return (
        <Box className={'tile-element__report-tool-section'} style={{ ...style, ...defaultStyle }}>
            <Stack direction={'row'} alignItems={'center'}>
                {['external report'].includes(tile.element_type || '') && (
                    <>
                        {ReportingToolIcon(tileicons, tile.reporting_tool_name || '')}
                        {tile.reporting_tool_name}
                    </>
                )}
                {['other external content'].includes(tile.element_type || '') && (
                    <>
                        {ReportingToolIcon(tileicons, tile.external_content_type_name || '')}
                        {tile.external_content_type_name}
                    </>
                )}
                {['metric', 'internal report'].includes(tile.element_type || '') && (
                    <Box>
                        <Box>
                            {t(ElementTypeNS.getElementTypeLabel((tile.element_type || '') as DashboardElementType))}
                        </Box>
                        {isShowExpiredNote == 'Y' &&
                            undefined !== tile?.last_display_generation_time &&
                            tile?.last_display_generation_time > '' && (
                                <>
                                    {'1' == tile.is_expired && (
                                        <Box sx={{ color: expiredNoteColor }}>
                                            {t('expired')}&nbsp;{wallFormatDateShort(tile.last_display_generation_time)}
                                        </Box>
                                    )}
                                    {/*
                                    {'1' != tile.is_expired && wallFormatDateShort(tile.last_display_generation_time)}
                                    */}
                                </>
                            )}
                    </Box>
                )}
            </Stack>
        </Box>
    );
};
